<template>
    <section class="content-section container-fluid px-3">
        <b-container fluid class="">
            <b-row class="justify-content-center align-items-center">
                <b-col lg="5">
                    <IconTitle :info="titleInfo" />
                    <p class="text-main-aux">The DUB accessory base is a product developed by Scan Top.</p>
                    <div class="erp-text">
                        <p>It has multinational patent support, and is suitable for 98% of car models.<br>
                            The installation steps are simple and the operation is more convenient than ever. See the
                            <a href="#videos" class="sp-a">installation videos</a> below.
                        </p>
                    </div>
                </b-col>
                <b-col lg="5">
                    <b-img src="@/assets/images/dub/certification.png" style="width:100%" />
                </b-col>
            </b-row>
        </b-container>
    </section>
</template>

<script>
import IconTitle from '@/components/IconTitle'
export default {
    components: { IconTitle},
    data() {
        return {
            titleInfo: {"title": "PATENT DUB", "src": require('@/assets/images/dub/icon.png')}
        }
    },
}
</script>

<style lang="scss">
    .sp-a {
        color: $color-main !important;
        text-decoration: underline !important;
    }
</style>